module.exports = __webpack_public_path__ + "img/f7b09c60ac531ceff1bee5970a57f62.f40d09eb.png";